import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import {
  ClientFileCategories,
  ClientFileCategoriesToHuman,
  ClientFileCategoryDescriptions,
  UploadedFile,
} from 'ah-api-gateways';
import FileUploader from 'ah-common-lib/src/common/components/upload/FileUploader.vue';
import { mergeMap, tap, map } from 'rxjs/operators';
import { waitForEntityChange } from 'ah-requests';
import { of } from 'rxjs';
import { getServices } from '@/app/services';
import { useAuthStore } from '@/app/store/authModule';
import { useIndividualSettingsStore } from '@/app/store/individualSettingsModule';
import { defaultAcceptanceFileTypes } from 'ah-common-lib/src/helpers/file';
import { isEqual } from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientDocumentsUploader',
  props: {
    files: { default: () => [] },
    categories: { default: () => [
      ClientFileCategories.PHOTO_ID,
      ClientFileCategories.PROOF_OF_ADDRESS,
      ClientFileCategories.PROOF_OF_FUNDS,
    ] },
    title: { default: 'User Identification Documents' },
    hideTypeInfo: { type: [Boolean, String], default: false }
  },
  emits: ["update:files"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:files', value: UploadedFile[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { files: UploadedFile[], categories: ClientFileCategories[], title: string, hideTypeInfo: boolean | string };

const authStore = useAuthStore();

const individualSettingsStore = useIndividualSettingsStore();





const services = getServices();

const clientId = computed(() => authStore.loggedInIdentity!.client!.id);

const filesInner = ref<UploadedFile[]>([]);

function getFile(category: ClientFileCategories) {
  return filesInner.value.find((document) => document.category === category) || null;
}

function uploadFile(file: File, category: ClientFileCategories) {
  return services.client.uploadDocument(clientId.value, category, file).pipe(
    mergeMap((file) => {
      if (file.finished) {
        return waitForEntityChange(
          () => services.client.getDocuments(clientId.value),
          (docs) => {
            return !!docs.find((d) => d.id === file.file.id);
          }
        ).pipe(
          map((docs) => {
            const document = docs.find((d) => d.id === file.file.id);
            if (document) {
              const currFileIndex = filesInner.value.findIndex((i) => i.category === document.category);
              currFileIndex > -1
                ? filesInner.value.splice(currFileIndex, 1, document)
                : filesInner.value.push(document);
            }
            return file;
          })
        );
      }
      return of(file);
    })
  );
}

function deleteFile(file: UploadedFile) {
  return services.client.deleteDocument(clientId.value, file.id).pipe(
    tap(() => {
      const currFileIndex = filesInner.value.findIndex((i) => i.category === file.category);
      if (currFileIndex > -1) {
        filesInner.value.splice(currFileIndex, 1);
      }

      individualSettingsStore.unsetClientDocument({ category: file.category as ClientFileCategories });
    })
  );
}

function downloadFile(file: UploadedFile) {
  return services.client.downloadSyncDocument(clientId.value, file);
}

watch(
  () => props.files,
  () => {
    filesInner.value = [...props.files];
  },
  { immediate: true }
);

watch(
  filesInner,
  () => {
    if (!isEqual(filesInner.value, props.files)) {
      emit('update:files', filesInner.value);
    }
  },
  { deep: true }
);

return { __sfc: true,authStore, individualSettingsStore, props, emit, services, clientId, filesInner, getFile, uploadFile, deleteFile, downloadFile, ClientFileCategoriesToHuman, ClientFileCategoryDescriptions, FileUploader, defaultAcceptanceFileTypes }
}

})